export default __webpack_public_path__ + "static/media/instagram-light.6f7cc165.svg";